<template>
  <router-link v-if="isUserAuth" :exact="exact" :to="route">
    <slot></slot>
  </router-link>
</template>

<script>
import Link from '../../mixins/Link'
import { doChecks } from '../../../router'
import { getters } from '../../utils'

export default {
  mixins: [Link],
  props: {
    exact: {
      default: false,
    },
  },
  data() {
    return {
      isUserAuth: true,
    }
  },
  computed: getters(),
  methods: {
    doChecks() {
      doChecks(this.route).catch(() => {
        this.isUserAuth = false
      })
    },
  },
  watch: {
    isAuth() {
      this.doChecks()
    },
  },
  created() {
    this.doChecks()
  },
}
</script>



// WEBPACK FOOTER //
// src/views/components/globals/Route.vue